function asyncDispatch(action, dispatch, param = {}) {
    return new Promise((resolve, reject) => {
        dispatch(action({ ...param, resolve, reject }));
    });
}

export default asyncDispatch;
